export const metaItemStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};
